import React from 'react';
import moment from 'moment';
import ColumnSorting from '../../components/TableFilter/ColumnsFilters/ColumnSorting';
import FilterInputField from '../../components/TableFilter/ColumnsFilters/FilterInputField';
import FilterDatePicker from '../../components/TableFilter/ColumnsFilters/FilterDatePicker';
import FilterSelect from '../../components/TableFilter/ColumnsFilters/FilterSelect';
import FilterTreeSelect from '../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';


export function voucherWaitingListColumn({ t, lang }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 100,
      sortable: true,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('waitingList_numberInList'),
      accessor: 'position',
      sortable: true,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: <ColumnSorting title={t('waitingList_kindergartenVoucherQueueId')} name="voucherId" />,
      accessor: 'kindergartenVoucherId',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="voucherId" type="number" />
    },
    {
      Header: (
        <ColumnSorting
          title={t('waitingList_receiveDate')}
          name="createdAt"
        />
      ),
      accessor: 'createdAt',
      Cell: row =>
        row.original.createdAt
          ? moment(row.original.createdAt).format('DD.MM.YYYY HH:mm')
          : '',
      style: { textAlign: 'center' },
      Filter: <FilterDatePicker name="createdAt" lang={lang} />
    },
    {
      Header: t('waitingList_childIin'),
      accessor: 'childIin',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="childIin" type="number" />
    },
    {
      Header: t('waitingList_childFullName'),
      accessor: 'childFullName',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="childFullName" />,
      Cell: ({ original }) =>
        `${original?.childSurname || ''} ${original?.childName ||
        ''} ${original?.childMiddleName || ''}`
    },
    {
      Header: (
        <ColumnSorting
          title={t('waitingList_queuedType')}
          name="queuedType"
        />
      ),
      accessor: 'queuedType ',
      Cell: ({ original: { queuedType } }) => queuedType[`${lang}_name`],
      Filter: <FilterSelect name="queuedType" dictCode="gu_queued_type" lang={lang} />
    },
    {
      Header: (
        <ColumnSorting title={t('waitingList_status')} name="status" />
      ),
      accessor: 'status ',
      Cell: ({ original: { appStatusWebStatus } }) =>
        appStatusWebStatus[`${lang}_name`],
      Filter: (
        <FilterSelect name="status" dictCode="waiting_list_status" lang={lang} />
      )
    },
    {
      Header: t('waitingList_serviceProviderLocation'),
      accessor: 'queuedRegion',
      Cell: ({ original: { queuedRegion } }) =>
        queuedRegion[`${lang}_name`],
      Filter: (
        <FilterTreeSelect lookupId="60" name="queuedRegion" lang={lang} />
      )
    },
    {
      Header: t('waitingList_serviceProviderBin'),
      accessor: 'serviceProviderBin',
      style: { textAlign: 'center' },
      Filter: <FilterInputField name="serviceProviderBin" type="number" />
    }
  ];
}
